import Vue from "vue"
import Vuex from "vuex"

import {syncSessionOnServer} from "@/main.js";

// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

const server = "https://api.open2options.org";

function summaryResponseFrom(chatResponse) {
  return { prompt: "", question: chatResponse };
}

function summaryResponsesFrom(chatResponse) {
  var responses = [];

  for (var index in chatResponse) {
    responses.push({ prompt: "", question: chatResponse[index] });
  }

  return responses;
}

function addQuestions(responseQuestionList, questionList) {
  for (var index in responseQuestionList) {
    questionList.unshift({ prompt: "", question: responseQuestionList[index] })
  }

  return questionList;
}

function addQuestionsFromLoop(loopList, infoList, loopVar, questionList) {
  if (loopList == undefined || infoList == undefined) {
    return questionList;
  }

  if (loopList.length != infoList.length ) {
    return questionList;
  }
  
  for (let loopListIndex in loopList) {
    let loopItems = infoList[loopListIndex][loopVar];
    var loopQuestions = [];

    for (let loopItemIndex in loopItems) {
      loopQuestions.unshift({ prompt: loopList[loopListIndex], question: loopItems[loopItemIndex] })
    }

    for (let loopQuestionIndex in loopQuestions) {
      questionList.unshift(loopQuestions[loopQuestionIndex]);
    }
  }

  return questionList;
}

export default new Vuex.Store({
  // plugins: [createPersistedState()],
  state: {
    accessCode: null,
    chatResponses: {'GoalsFillin': ''},
    summaryResponses: {},
    interstitialSummaries: [],
    messagesData: [],
    sessionID: null,
    // arm: null,
    currentSectionName: "",
    sessionFinalized: null,
    baselineDateTime: null
 },
  mutations: {
    setAccessCode(state, accessCode) {
      state.accessCode = accessCode;
    },

    setServerChatSessionID(state, session_id) {
   //  document.cookie = "QSessionId="+session_id;
      var cookieName = 'QSessionId';
      var cookieValue = session_id;
      //document.cookie = cookieName + "=" + cookieValue +";domain=.open2options.org;path=/";
      document.cookie = "QSessionId="+session_id + ";SameSite=None; Secure";
      state.sessionID = session_id;
    },

    // setArm(state, arm) {
    //   state.arm = arm;
    // },

    setBaselineDateTime(state, baselineDateTime) {
      state.baselineDateTime = baselineDateTime;
    },

    setCurrentSectionName(state, currentSectionName) {
      state.currentSectionName = currentSectionName;
    },

    setSessionFinalized(state, sessionFinalizedDate) {
      state.sessionFinalized = sessionFinalizedDate;
    },
    
    clearResponses(state) {
        state.chatResponses = {'GoalsFillin': ''};
        state.summaryResponses = {};
        state.messagesData = [];
    },

    saveMessageToServer(state, message) {
      syncMessagesWithServer(state.sessionID, state.token, state.messagesData);
      saveMessageToServer(state.sessionID, message, state.token);
    },

    setResponse(state, response) {
      let chatbotState = response.state;
      
      if (chatbotState.forLoopState !== null && chatbotState.forLoopState.varName !== undefined) {
        
        // check to see if we are past the end of the loop
        let loopingValues = state.chatResponses[chatbotState.forLoopState.varName];
        if (chatbotState.forLoopState.index >= loopingValues.length && response.value.length > 0) {
          var value;

          // ignore empty responses
          if (typeof response.value == "string") {
            if (response.value.length > 0) {
              value = response.value
            }
          } else {
            var nonEmptyResponses = response.value.filter(function(value, index, arr){
              return value.length > 0;
            });
            value = nonEmptyResponses
          }

          state.chatResponses[response.key] = value;
        }
        else {
          // We are making:
          // CancerDetails__info = [{"details": details for A}, {"details": details for B}]
          // These parallel the items in CancerDetails

          let loopContextVar = chatbotState.forLoopState.loopContextVar; // cancer_details__info
          let response_list = chatbotState.context[loopContextVar] = chatbotState.context[loopContextVar] || [];
          let response_object = response_list[chatbotState.forLoopState.index] = response_list[chatbotState.forLoopState.index] || {};
          
          if (typeof response.value == "string") {
            if (response.value.length > 0) {
              response_object[response.key] = response.value
            }
          } else {
            let nonEmptyResponses = response.value.filter(function(value, index, arr){
              return value.length > 0;
            });
            response_object[response.key] = nonEmptyResponses
          }
          
          state.chatResponses[loopContextVar] = state.chatResponses[loopContextVar] || [];
          state.chatResponses[loopContextVar][chatbotState.forLoopState.index] = response_object;
        }
      }
      else {
        if (typeof response.value == "string") {
          if (response.value.length > 0) {
            state.chatResponses[response.key] = response.value
          }
        } else {
          var nonEmpty = response.value.filter(function(value, index, arr) {
            return value.length > 0;
          });

          state.chatResponses[response.key] = nonEmpty;
        }
      }
    },

    resumeSession(state, data) {
      state.currentSectionName = data.sectionName;
      state.summaryResponses = data.summaryResponses;
      state.chatResponses = data.chatResponses;
      state.messagesData = [];

      // update current section for resume
      switch (data.sectionName) {
        case "situation":
          break;

          case "options":
            state.interstitialSummaries = ["situation"];
            break;

          case "network":
            state.interstitialSummaries = ["situation", "options"];
            break;

          case "goals":
            state.interstitialSummaries = ["situation", "options", "network"];
            break;

          case "evaluation":
            state.interstitialSummaries = ["situation", "options", "network", "goals"];
            
            break;

        default:
          break;
      }
    },

    viewSession(state, data) {
      state.summaryResponses = data.summaryResponses;
      state.chatResponses = data.chatResponses;
    },

    createSummaryResponses(state, sectionName) {
      let completedSummaries = state.interstitialSummaries;

      // update current section for resume
      switch (sectionName) {
        case "situation":
          state.currentSectionName = "options";
          break;

          case "options":
            state.currentSectionName = "network";
            break;

          case "network":
            state.currentSectionName = "goals";
            break;

          case "goals":
            state.currentSectionName = "evaluation";
            break;

          case "evaluation":
            state.currentSectionName = "final";
            break;

        default:
          break;
      }

      if (completedSummaries.includes(sectionName)) {
        return;
      }

      let chatResponses = state.chatResponses;
      var summaryResponses = state.summaryResponses || [];
      
      if (sectionName == 'final') {
        state.sessionFinalized = new Date();
      }

      // situation
      if (sectionName == 'situation') { 
        summaryResponses.CancerType = summaryResponseFrom(chatResponses.CancerType);
        summaryResponses.CancerDetails = summaryResponsesFrom(chatResponses.CancerDetails);
        summaryResponses.OverallHealth = summaryResponsesFrom(chatResponses.OverallHealth);
      }

      // options
      if (sectionName == 'options' && !completedSummaries.includes(sectionName)) { 
        if (chatResponses['KnowTreatmentOptionsYes'] !== undefined) {
          summaryResponses.dontKnowTreatment = false;
        }
        else {
          summaryResponses.dontKnowTreatment = true;
        }
      
        summaryResponses.OptionsDetails = summaryResponsesFrom(chatResponses.OptionsDetails);
      }

      // network
      if (sectionName == 'network') { 
        summaryResponses.SupportMedical = summaryResponsesFrom(chatResponses.SupportMedical);
        summaryResponses.SupportPersonal = summaryResponsesFrom(chatResponses.SupportPersonal);

        if (chatResponses['KnowMedicalSupportTeamNo'] !== undefined) {
          summaryResponses.dontKnowMedicalTeam = true;
        }
        else {
          summaryResponses.dontKnowMedicalTeam = false;
        }

        if (chatResponses['HasPersonalSupportNo'] !== undefined) {
          summaryResponses.noPersonalSupport = true;
        }
        else {
          summaryResponses.noPersonalSupport = false;
        }
      }

      // goals
      if (sectionName == 'goals') { 
        summaryResponses.values = summaryResponsesFrom(chatResponses.values)
        summaryResponses.values_info = {}
        // this should look like {'Work': {'Hopes and Fears': ['work hopes and fears']}}

        for (var index in summaryResponses.values) {
          let value = summaryResponses.values[index]
          
          let hopes = chatResponses.values__info[index]['Hopes and Fears']
          
          let valueInfo = {'Hopes and Fears': hopes}
          summaryResponses.values_info[value.question] = valueInfo
        }

        summaryResponses.GoalsFillin = summaryResponsesFrom(chatResponses.GoalsFillin)
        /// this should look like {'Pets': {'Hopes and Fears': ['pets hopes and fears']}}

        for (var fillin_index in summaryResponses.GoalsFillin) {
          let value = summaryResponses.GoalsFillin[fillin_index]
          
          let hopes = chatResponses.GoalsFillin__info[fillin_index]['Hopes and Fears']
        
          let valueInfo = {'Hopes and Fears': hopes}
          summaryResponses.values_info[value.question] = valueInfo
        }

        let values = summaryResponsesFrom(chatResponses.values)
        summaryResponses.values_list = {}
        // this should look like {'Work': {'Meaning': ['work meaning'], 'Hopes': ['Work hopes'], 'Fears': ['Work fears']}}

        for (let value_index in values) {
          let value = values[value_index]
          
          let hopesfears = chatResponses.values__info[value_index]['Hopes and Fears']
          
          var goals1 = []
          
          for (let hopefear in hopesfears) {
            goals1.push({prompt: 'What hopes and fears do I have about ' + value.question, question: hopesfears[hopefear] });
          }

          summaryResponses.values_list[value.question] = goals1
        }

        let value_fillins = summaryResponsesFrom(chatResponses.GoalsFillin)
        for (let value_index in value_fillins) {
          let value = value_fillins[value_index]
          
          let hopesfears = chatResponses.GoalsFillin__info[value_index]['Hopes and Fears']
          
          var goals2 = []
          
          for (let hopefear in hopesfears) {
            goals2.push({prompt: 'What hopes and fears do I have about ' + value.question, question: hopesfears[hopefear] });
          }

          summaryResponses.values_list[value.question] = goals2
        }

        summaryResponses.values = values.concat(value_fillins);
      }

      // question list
      var questions = JSON.parse(JSON.stringify(state.summaryResponses.QuestionsConcerns || []));

      // situation questions
      if (sectionName == "situation") {
        questions = addQuestions(chatResponses.TopOfMindSituation, questions);
        questions = addQuestionsFromLoop(chatResponses.CancerDetails, chatResponses.CancerDetails__info, 'Details', questions);
        questions = addQuestions(chatResponses.SituationSampleQs, questions);
      }

      // options questions
      if (sectionName == "options") {
        questions = addQuestions(chatResponses.OptionsGeneral, questions);
        questions = addQuestionsFromLoop(chatResponses.OptionsDetails, chatResponses.OptionsDetails__info, 'Details', questions);
        questions = addQuestions(chatResponses.OptionSampleQs, questions);
      }

      // network questions
      if (sectionName == "network") {
        questions = addQuestionsFromLoop(chatResponses.SupportMedical, chatResponses.SupportMedical__info, 'SupportQsMedical', questions);
        questions = addQuestions(chatResponses.SupportSampleQs, questions);
      }

      // goals questions
      if (sectionName == "goals") {
        questions = addQuestions(chatResponses.goals_sample_question, questions)
      }
      
      // evaluation questions
      if (sectionName == "evaluation" || sectionName == "final") {
        questions = addQuestions(chatResponses.EvaluationQuestions, questions)
        questions = addQuestions(chatResponses.EvaluationConcerns, questions)
        questions = addQuestions(chatResponses.EvaluationSampleQs, questions)
      }

      state.summaryResponses.QuestionsConcerns = questions;
      state.summaryResponses = summaryResponses;
      state.interstitialSummaries.push(sectionName);

      syncSessionOnServer();
    },

    setSummaryResponse(state, summaryResponse) {
      var summaryResponses = JSON.parse(JSON.stringify(state.summaryResponses));
      if (summaryResponse.key.split(".").length == 2) {
        let keys = summaryResponse.key.split(".");
        summaryResponses[keys[0]][keys[1]] = summaryResponse.value;
      }
      else if (summaryResponses[summaryResponse.key].question !== undefined) {
        summaryResponses[summaryResponse.key].question = summaryResponse.value;
      }
      else {
        summaryResponses[summaryResponse.key] = summaryResponse.value;
      }
      
      state.summaryResponses = summaryResponses;

      syncSessionOnServer();
    },
  
    resetSituation(state) {
      state.chatResponses.CancerType = "";
      state.chatResponses.CancerDetails = [];
      state.chatResponses.OverallHealth = [];
      
      state.chatResponses.TopOfMindSituation = [];
      state.chatResponses.CancerDetails = [];
      state.chatResponses.CancerDetails__info = [];
      state.chatResponses.SituationSampleQs = [];
    },

    resetOptions(state) {
      state.chatResponses['c87b3d5a-bc74-4b3a-8ff0-37d2bffa993d'] = '';
      state.chatResponses.OptionsDetails = [];

      state.chatResponses.OptionsGeneral = [];
      state.chatResponses.OptionsDetails = [];
      state.chatResponses.OptionsDetails__info = [];
      state.chatResponses.OptionSampleQs = [];
    },

    resetNetwork(state) {
      state.chatResponses.SupportMedical = [];
      state.chatResponses.SupportMedical__info = [];
      state.chatResponses.SupportPersonal = [];
      state.chatResponses.SupportSampleQs = [];
    },

    resetGoals(state) {
      state.chatResponses.values = [];
      state.chatResponses.values__info = [];
      state.chatResponses.goals_sample_question = [];
      state.chatResponses.GoalsFillin = "";
    },

    resetEvaluation(state) {
      state.chatResponses.EvaluationQuestions = [];
      state.chatResponses.EvaluationConcerns = [];
      state.chatResponses.EvaluationSampleQs = [];
    },
  },

  actions: {}
});
